import Component from './Component';
import React from 'react';
import {Button} from 'react-bootstrap';
import classNames from 'classnames';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';


export default class ActionButton extends Component {

	static defaultProps = {
		alert: 'Nemáte oprávnění akci provést!'
	};

	static contextTypes = {
		store: React.PropTypes.object
	};

	handleClick() {
		if (!this.props.disabled) {
			this.props.onClick();
		}
		else {
			if (this.props.onDisabledClick) {
				this.props.onDisabledClick();
			}
			if (this.props.alert) {
				const alert = new AlertWindow('Oprávnění', this.props.alert);
				alert.show(this.context.store.dispatch);
			}
		}
	}

	render() {
		return (
				<Button bsStyle={this.props.bsStyle}
						className={classNames({'input-group':true, disabled: this.props.disabled})}
						onClick={()=>this.handleClick()}>
					<i className={this.props.icon + ' position-left'}></i>{this.props.children}
				</Button>
			)
	}
}


// WEBPACK FOOTER //
// ./src/components/ActionButton.js